import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../lib/services/modal.service';
import { UnitService } from '../../settings-module/services/unit';
import { take } from 'rxjs/operators';
import { UnitEmployment } from '../../settings-module/models/unitEmployment';
import { TranslateService } from '@ngx-translate/core';
import * as unitActions from '../../settings-module/actions/unit';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';

@Component({
  selector: 'mj-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss'],
})
export class IntroductionComponent extends ModalComponent {
  introTitle: string;

  constructor(
    private unitService: UnitService,
    private translate: TranslateService,
    private store: Store<fromRoot.State>
  ) {
    super();

    this.data.pipe(take(1)).subscribe((unitEmployment: UnitEmployment) => {
      unitEmployment.has_seen_intro = true;

      this.store.dispatch(
        new unitActions.UpdateUnitEmployment({
          unitEmployment: unitEmployment,
        })
      );

      this.translate
        .get('introduction_title', {
          name: unitEmployment.user.first_name,
        })
        .subscribe(text => {
          this.introTitle = text;
        });
    });
  }

  closeModal() {
    this.resolve.next(null);
  }
}
